module.exports = __webpack_public_path__ + "img/13.c1d44e4d.jpg";